// eslint-disable-next-line
// @ts-nocheck
import GOOD_CONFIG from "./config/good";
import SCIENCE_CONFIG from "./config/science";

const config = {
  GOOD_CONFIG,
  SCIENCE_CONFIG,
};

const setRootVar = (obj) => {
  // 创建一个新的 CSS 规则
  const style = document.createElement("style");
  document.head.appendChild(style);

  // 根据 obj 动态生成 CSS 规则字符串
  const rules = `
        :root {
            ${Object.entries(obj)
              .map(([key, value]) => `${key}: ${value};`)
              .join("\n")}
        }
    `;

  return style.sheet.insertRule(rules, style.sheet.cssRules.length);
};

const initCssVar = (obj) => {
  const _o = {};
  for (const key in obj) {
    // eslint-disable-next-line no-prototype-builtins
    if (obj.hasOwnProperty(key)) {
      _o[`--${key}`] = obj[key];
    }
  }
  return _o;
};

window.initConfig = (type = "GOOD_CONFIG") => {
  const _config = config[type];
  const style = _config.style;
  setRootVar(initCssVar(style));
  window._config = _config;
};
